var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{
        active: _vm.active,
        pulse: _vm.pulse,
        disabled: _vm.disabled,
        'link-button': _vm.isLinkButton,
        'important': _vm.isImportantButton,
        },on:{"click":_vm.handelInput}},[_c('label',[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }